var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePage',{attrs:{"typePage":"Reminders","itemList":_vm.getRemindersData,"isShowSpinner":_vm.isShowSpinner}})
}
var staticRenderFns = []

export { render, staticRenderFns }